import { motion } from "framer-motion";
import WorldMap from "../WorldMap/WorldMap";

export default function WorldMapDemo() {
  return (
    <div className="py-20  w-full">
      <div className="max-w-7xl mx-auto text-center">
        <p className="font-bold text-xl md:text-4xl dark:text-white text-black">
          Remote{" "}
          <span className="text-neutral-400">
            {"Connectivity".split("").map((letter, idx) => (
              <motion.span
                key={idx}
                className="inline-block"
                initial={{ x: -10, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: idx * 0.04 }}
              >
                {letter}
              </motion.span>
            ))}
          </span>
        </p>
        <p className="text-sm md:text-lg text-neutral-500 max-w-2xl mx-auto py-4">
          Break free from traditional boundaries. Work from anywhere, at the
          comfort of your own studio apartment. Perfect for Nomads and
          Travellers.
        </p>
      </div>

      <WorldMap
        dots={[
          {
            start: { lat: 23.8742549, lng: 90.3981854, label: "Dhaka" },
            end: { lat: 34.0522, lng: -118.2437, label: "Los Angeles" },
          },
          {
            start: { lat: 64.2008, lng: -149.4937, label: "Fairbanks" },
            end: { lat: -15.7975, lng: -47.8919, label: "Brasília" },
          },
          {
            start: { lat: -15.7975, lng: -47.8919, label: "Brasília" },
            end: { lat: 38.7223, lng: -9.1393, label: "Lisbon" },
          },
          {
            start: { lat: 51.5074, lng: -0.1278, label: "London" },
            end: { lat: 28.6139, lng: 77.209, label: "New Delhi" },
          },
          {
            start: { lat: 28.6139, lng: 77.209, label: "New Delhi" },
            end: { lat: 43.1332, lng: 131.9113, label: "Vladivostok" },
          },
          {
            start: { lat: 28.6139, lng: 77.209, label: "New Delhi" },
            end: { lat: -1.2921, lng: 36.8219, label: "Nairobi" },
          },
        ]}
      />
    </div>
  );
}